// extracted by mini-css-extract-plugin
var _1 = "button-aBmuU";
var _2 = "form-Y41C3";
var _3 = "new-tb_rh";
var _4 = "row-si1WW";
var _5 = "save-raFiS";
var _6 = "section-ZIENZ";
var _7 = "visibility-D9i8m";
export { _1 as "button", _2 as "form", _3 as "new", _4 as "row", _5 as "save", _6 as "section", _7 as "visibility" }
